module.exports = __webpack_public_path__ + "img/3-1.d080979c.png";